import { API_CALL_FAILED, API_CALL_SUCCESS } from './actionTypes';

export const apiCallFailed = msg => ({
  type: API_CALL_FAILED,
  msg,
});

export const apiCallSuccess = msg => ({
  type: API_CALL_SUCCESS,
  msg,
});
